
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from '../providers/userContext';
import { hasRouteAccess } from './accessControl';
import { getPortalBase, isSubscriptionRestricted, isSubscriptionSafePath } from '../../shared/constants/subscriptionAccess';

const ProtectedRoute = ({ allowedRoles, requiredPermissions }) => {
  const { user, isInitializing } = useUser();
  const { pathname } = useLocation();

  // Wait while a saved token is being validated.
  if (isInitializing) return null;

  if (!user) return <Navigate to="/login" replace />;

  if (!hasRouteAccess({ user, allowedRoles, requiredPermissions })) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (isSubscriptionRestricted(user) && !isSubscriptionSafePath(user, pathname)) {
    return <Navigate to={`${getPortalBase(user)}/dashboard`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;